import { AutogenLayoutRecurringPayAdjustmentList } from "./autogen/AutogenLayoutRecurringPayAdjustmentList";
import { Component, Label, TableRowDisplayEvent } from "@mcleod/components";
import { CommonTooltips } from "@mcleod/common";
import { DisplayType, ModelRow, UrlUtil } from "@mcleod/core";

export class RecurringPayAdjustmentList extends AutogenLayoutRecurringPayAdjustmentList {

    onLoad(): void | Promise<void> {
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search);
        if (urlProp) {
            this.mainDataSource.search({
                payee_id: urlProp.payeeId,
                cutoff_date: urlProp.cutoffDate,
                currency: urlProp.currency,
                ready_to_pay_flag: "Y || N"
            }, null, this.layoutName);
        } else {
            this.mainDataSource.search(null, null, this.layoutName);
        }
    }

    tableRecuringPayAdjustmentsOnRowDisplay(event: TableRowDisplayEvent): void {
        const tableRow = event.getTableRow();
        tableRow.forEveryChildComponent((component) => {
            this.setTooltipContent(component, tableRow.data);
        });
    }

    setTooltipContent(component: Component, modelRow: ModelRow) {
        switch (component.id) {
            case "textboxPayeeID": {
                if (modelRow.get("drs_payee.type_of") == "R") {
                    CommonTooltips.setTooltipContentLayout(component, modelRow.get("payee_id"), "lme/powerbroker/CarrierQuickInfo");
                }
                else if (modelRow.get("drs_payee.type_of") == "A") {
                    CommonTooltips.setTooltipContentLayout(component, modelRow.get("payee_id"), "lme/settlement/AgentQuickInfo");
                }
                break;
            }
            default: {
                if (component instanceof Label && component.displayType === DisplayType.STRING) {
                    component.tooltip = modelRow.get(component.field);
                }
            }
        }
    }
}
